import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { FormControl, ReactiveFormsModule } from '@angular/forms'
import { I18nService, MessageGetter } from 'app/_services/i18n.service'
import { I18nDirective } from 'app/shared/directives/app-i18n.directive'
import { InputValidationDirective } from 'app/shared/directives/input-validation.directive'
import { FormFloatingComponent } from 'app/shared/form/form-floating/form-floating.component'

@Component({
    selector: 'form-address-floor',
    template: ` <form-floating>
        <label i18n="@@addressDetails_floor_label" app-i18n="addressDetails_floor_label">Verdieping</label>
        <select [formControl]="formFloor" class="form-select" data-cy="floor" (input)="formMoveType?.patchValue('stairs')" input-validation>
            <option [ngValue]="null" selected disabled i18n="@@addressDetails_floor_select" app-i18n="addressDetails_floor_select">
                Kies een etage
            </option>
            <option *ngFor="let option of optionsFloor" [ngValue]="option.value">{{ option.label }}</option>
        </select>
    </form-floating>`,
    standalone: true,
    imports: [CommonModule, FormFloatingComponent, InputValidationDirective, ReactiveFormsModule, I18nDirective],
})
export class FormAddressFloorComponent {
    @Input({ required: true }) formFloor: FormControl
    @Input() formMoveType: FormControl

    // Shortcut
    readonly i18n: MessageGetter = this.i18nService.getMessage.bind(this.i18nService)

    optionsFloor = [
        { value: 0, label: this.i18n('addressDetails_floor_ground') },
        { value: -1, label: this.i18n('addressDetails_floor_sous') },
        { value: 1, label: this.i18n('addressDetails_floor_first') },
        { value: 2, label: this.i18n('addressDetails_floor_second') },
        { value: 3, label: this.i18n('addressDetails_floor_third') },
        { value: 4, label: this.i18n('addressDetails_floor_fourth') },
        { value: 5, label: this.i18n('addressDetails_floor_fifth') },
        { value: 6, label: this.i18n('addressDetails_floor_sixth') },
        { value: 7, label: this.i18n('addressDetails_floor_seventh') },
        { value: 8, label: this.i18n('addressDetails_floor_eigth') },
        { value: 9, label: this.i18n('addressDetails_floor_ninth') },
        { value: 10, label: this.i18n('addressDetails_floor_tenPlus') },
    ]

    constructor(private i18nService: I18nService) {}
}
